<template>
    <dynamic-dialog />
    <confirm-dialog />
    <prime-toast position="bottom-right" />
    <slot />
</template>

<script setup lang="ts">
import DynamicDialog from 'primevue/dynamicdialog'
import ConfirmDialog from 'primevue/confirmdialog'
import PrimeToast from 'primevue/toast'
</script>
